import Slider from "react-slick/lib/slider";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SearchArticle from "../components/SearchArticle";
import { TfiArrowCircleLeft, TfiArrowCircleRight } from "react-icons/tfi";
import { RxBookmark } from "react-icons/rx";
import { Badge, Button, Card, Col, Container, Row } from "react-bootstrap";
import articleImg1 from "../assets/images/article-01.jpg";
import articleImg2 from "../assets/images/article-02.jpg";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { BsImage } from "react-icons/bs";

export default function Home() {
  const navigate = useNavigate();
  const settings = {
    dots: false,
    nextArrow: <TfiArrowCircleRight />,
    prevArrow: <TfiArrowCircleLeft />,
    infinite: true, // infinite loop
    speed: 500, // transition speed
    slidesToShow: 3, // show 3 items initially
    slidesToScroll: 1, // scroll one item at a time
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024, // screen width < 1024px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600, // screen width < 600px
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const saveSettings = {
    dots: false,
    nextArrow: <TfiArrowCircleRight />,
    prevArrow: <TfiArrowCircleLeft />,
    infinite: false,
    speed: 500,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 1.5 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const items = [
    {
      id: 1,
      title:
        "Learning the natural history of human disease with generative transformers",
      image: articleImg1,
      PMID: 20878177,
      trial: "Clinical Trial",
      type: ["Wang Q", "Xiao ZX", "Zheng X", "Xiang N", "Schett G"],
    },
    {
      id: 2,
      title:
        "Drug resistance in idiopathic generalized epilepsies: Evidence and concepts",
      image: articleImg2,
      PMID: 308255177,
      trial: "Clinical Trial",
      type: ["Wang Q", "Xiao ZX", "Zheng X", "Xiang N", "Schett G"],
    },
    {
      id: 3,
      title:
        "Orforglipron, an Oral Small-Molecule GLP-1 Receptor Agonist for Obesity Treatment.",
      image: null,
      PMID: 25484544,
      trial: "Clinical Trial",
      type: ["Wang Q", "Xiao ZX", "Zheng X", "Xiang N", "Schett G"],
    },
    {
      id: 4,
      title:
        "In Vivo CD19 CAR T-Cell Therapy for Refractory Systemic Lupus Erythematosus",
      image: articleImg2,
      PMID: 208781548,
      trial: "Clinical Trial",
      type: ["Wang Q", "Xiao ZX", "Zheng X", "Xiang N", "Schett G"],
    },
    {
      id: 5,
      title:
        "Time-resolved reprogramming of single somatic cells into totipotent states during plant",
      image: articleImg1,
      PMID: 45878177,
      trial: "Clinical Trial",
      type: ["Wang Q", "Xiao ZX", "Zheng X", "Xiang N", "Schett G"],
    },
  ];

  const [article, setArticle] = useState(items);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const loginStatus = localStorage.getItem("isLoggedIn");
    setIsLoggedIn(loginStatus === "true");
  }, []);

  const handleViewAllClick = () => {
    navigate("/explore"); // Navigate to /explore page
  };

  const handleLogout = () => {
    // Remove login status from localStorage
    localStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false); // Hide the trending article section after logout
  };

  return (
    <>
      <SearchArticle />
      <Container className="article-container">
        <div className="trending-article ">
          <Row className="mb-3 align-items-center">
            <Col xs={6}>
              <h2 className="mb-0">Trending Articles</h2>
            </Col>
            <Col xs={6} className="text-end">
              <Button variant="outline-secondary" onClick={handleViewAllClick}>
                View all
              </Button>
            </Col>
          </Row>

          <Slider {...settings}>
            {article.map((item) => (
              <Link to="#" key={item.id}>
                <Card className="article-card">
                  <Card.Header className="p-0 bg-transparent border-bottom-0 ratio ratio-16x9">
                    {
                      item?.image !== null ?
                        <img src={item?.image} alt="" />
                        : <div className="image-placeholder">
                          <BsImage />
                        </div>
                    }
                  </Card.Header>
                  <Card.Body className="p-0">
                    <Card.Title>{item?.title}</Card.Title>
                    <div className="tag-list">
                      {item?.type?.map((tag, index) => (
                        <Badge key={index} className="tag">
                          {tag}
                        </Badge>
                      ))}
                    </div>
                    <p>PMID: {item?.PMID}</p>
                    <p className="trial">{item?.trial}</p>
                  </Card.Body>
                  <Card.Footer className="p-0 bg-transparent border-top-0">
                    <Button variant="outline-secondary">READ MORE</Button>
                  </Card.Footer>
                </Card>
              </Link>
            ))}
          </Slider>
        </div>
        <div className="join-with-us text-center">
          <Row className="gx-2">
            <Col xs={12} md={6} className="mb-2 mb-md-0">
              <div className="join-trial">
                <h2>Start exploring smarter health insights today.</h2>
                <Button variant="primary">Join Free Trial</Button>
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div className="join-community">
                <h2>Be part of the conversation around health and research.</h2>
                <Button variant="primary">Join Our Community</Button>
              </div>
            </Col>
          </Row>
        </div>
        {isLoggedIn && (
          <div className="trending-article trending-article-save">
            <Row className="mb-3 align-items-center">
              <Col xs={6}>
                <h2 className="mb-0">Save Articles</h2>
              </Col>
              <Col xs={6} className="text-end">
                <Button
                  variant="outline-secondary"
                  onClick={handleViewAllClick}
                >
                  View all
                </Button>
              </Col>
            </Row>

            <Slider {...saveSettings} className="save-article">
              {article.map((item) => (
                <Link to="#" key={item.id}>
                  <Card className="article-card save-article-card">
                    <Row>
                      <Col xs={12} md={2} className="pe-md-0 mb-4 mb-md-0">
                        <Card.Header className="p-0 bg-transparent border-bottom-0 ratio ratio-1x1">
                          {
                            item?.image !== null ?
                              <img src={item?.image} alt="" />
                              : <div className="image-placeholder">
                                <BsImage />
                              </div>
                          }
                        </Card.Header>
                      </Col>
                      <Col xs={10} md={9}>
                        <Card.Body className="p-0">
                          <Card.Title className="mt-0">
                            {item?.title}
                          </Card.Title>
                          <div className="tag-list">
                            {item?.type?.map((tag, index) => (
                              <Badge key={index} className="tag">
                                {tag}
                              </Badge>
                            ))}
                          </div>
                          <p>PMID: {item?.PMID}</p>
                          <p className="trial">{item?.trial}</p>
                        </Card.Body>
                        <Card.Footer className="p-0 bg-transparent border-top-0">
                          <Button variant="outline-secondary">READ MORE</Button>
                        </Card.Footer>
                      </Col>
                      <Col xs={2} md={1} className="text-end">
                        <Button className="save-btn">
                          <RxBookmark />
                        </Button>
                      </Col>
                    </Row>
                  </Card>
                </Link>
              ))}
            </Slider>
          </div>
        )}
      </Container>
    </>
  );
}
